export default __webpack_public_path__ + "static/media/NoProfile.a67b18fc.svg";